import { useAppDispatch } from "../../../../../common/state/hooks";
import { resetByDeviceId as resetDeviceList } from "../../../../../common/state/Slices/ConnectedDeviceSlice";
import { resetByDeviceId as resetInstalledGadgets } from "../../../../../common/state/Slices/InstalledGadgetsSlice";
import { resetByDeviceId as resetInstalledGadgetsOnAllDevices } from "../../../../../common/state/Slices/InstallOnAllDeviceSlice";
import { DeviceDisconnectedEventBody } from "../../models/body";
import { GarudaResponse } from "../../models/events";

export const useDeviceDisconnection = () => {
    const dispatch = useAppDispatch();

    const handleOnDeviceDisconnect = (response: GarudaResponse) => {
        const body = response.body as DeviceDisconnectedEventBody;
        const payload = {
            deviceId: body.deviceId
        };
        dispatch(resetDeviceList(payload));
        dispatch(resetInstalledGadgets(payload));
        dispatch(resetInstalledGadgetsOnAllDevices(payload));
    };

    return {
        handleOnDeviceDisconnect
    }
}